//奖励 确认表格

import {getStore} from '@/util/store'

function getInsureTypesData() {
	let temp = getStore({name: 'insureTypes'})
	temp.push({
		name: '方案编号',
		type: '',
	})
	return temp
}

//后端
export const couponAfterList = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		addBtn: false,
		excelBtn: false,
		copyBtn: true,
		align: 'center',
		index: true,
		indexLabel: '序号',
		menuAlign: 'center',
		labelWidth: 120,
		menuType: 'menu',
		menuBtnTitle: '其他操作',
		column: [
			{
				label: '名称',
				prop: 'name',
				search: true,
				width: 120,
				rules: [
					{
						required: true,
						message: '请输入佣金券名称',
						trigger: 'blur',
					},
				],
			},
			{
				label: '奖励费率',
				prop: 'feeRate',
				rules: [
					{
						required: true,
						message: '请输入奖励费率',
						trigger: 'blur',
					},
					{
						validator: (rule, value, callback) => {
							value = Number(value)
							let regNumber = /^[0-9.]+$/
							if (!regNumber.test(value)) {
								callback(new Error('奖励费率只能为数字和.！'))
							} else if (value <= 0) {
								callback(new Error('奖励费率范围有误！'))
							} else {
								callback()
							}
						},
						trigger: 'blur',
					},
				],
				append: '%',
			},
			{
				label: '适用方案',
				prop: 'insureTypesAble',
				row: true,
				type: 'select',
				hide: true,
				dicData: [
					{
						label: '全部方案',
						value: 1,
					},
					{
						label: '部分方案',
						value: 2,
					},
					{
						label: '方案编号',
						value: 3,
					},
				],
				rules: [
					{
						required: true,
						message: '请选择适用产品',
						trigger: 'blur',
					},
				],
			},
			{
				label: '方案',
				prop: 'insureTypes',
				width: 160,
				display: false,
				type: 'select',
				multiple: true,
				search: true,
				overHidden: true,
				dicData: getInsureTypesData(),
				dataType: 'string',
				props: {
					label: 'name',
					value: 'type',
				},
				rules: [
					{
						required: true,
						message: '请选择方案',
						trigger: 'blur',
					},
				],
			},
			{
				label: '旧方案编号',
				prop: 'productIds',
				width: 120,
				display: false,
				placeholder: '请输入方案编号，多个编号用英文逗号分隔',
				formatter: ({productIds}) => {
					return productIds ? productIds : '--'
				},
				rules: [
					{
						required: true,
						message: '请填写方案编号',
						trigger: 'blur',
					},
					{
						validator: (rule, value = '', callback) => {
							if (value && !/^[0-9,]+$/.test(value)) {
								callback(new Error('方案编号只能为数字，多个编号用英文逗号分隔'))
							} else {
								callback()
							}
						},
						trigger: 'blur',
					},
				],
			},
			{
				label: '发放方式',
				prop: 'sendType',
				type: 'select',
				width: 120,
				disabled: false,
				dicData: [
					{
						label: '新注册渠道发放',
						value: '1',
					},
					{
						label: '指定时间向指定渠道发放',
						value: '2',
					},
				],
				rules: [
					{
						required: true,
						message: '请选择发放方式',
						trigger: 'blur',
					},
				],
			},
			{
				label: '数量（张）',
				prop: 'count',
				type: 'number',
				display: false,
				precision: 0,
				width: 100,
				controls: false,
				min: 1,
				rules: [
					{
						required: true,
						message: '请输入数量',
						trigger: 'blur',
					},
				],
				formatter: ({count = ''}) => (count.includes(',') ? '张数不同' : `${count}张`),
			},
			{
				label: '有效期（天）',
				prop: 'validityDuration',
				type: 'number',
				width: 120,
				precision: 0,
				display: false,
				controls: false,
				min: 1,
				rules: [
					{
						required: true,
						message: '请输入有效期（天）',
						trigger: 'blur',
					},
				],
				formatter: ({validityDuration = ''}) => (validityDuration ? `${validityDuration}天` : '--'),
			},
			{
				label: '发送时间',
				prop: 'issueTime',
				display: false,
				type: 'datetime',
				width: 120,
				formatter: ({issueTime}) => {
					return issueTime ? issueTime : '--'
				},
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
					},
				},
				format: 'yyyy-MM-dd HH:mm:ss',
				valueFormat: 'yyyy-MM-dd HH:mm:ss',
				rules: [
					{
						required: true,
						message: '请选择发送时间',
						trigger: 'blur',
					},
				],
			},
			{
				label: '有效期',
				prop: 'validTime',
				type: 'datetimerange',
				display: false,
				valueFormat: 'yyyy-MM-dd HH:mm:ss',
				format: 'yyyy-MM-dd HH:mm:ss',
				defaultTime: ['00:00:00', '23:59:59'],
				startPlaceholder: '选择生效时间',
				endPlaceholder: '选择失效时间',
				rangeSeparator: '至',
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
					},
				},
				hide: true,
				row: true,
				span: 24,
				rules: [
					{
						required: true,
						trigger: 'blur',
						message: '请选择有效期',
					},
					{
						validator: (rule, value = [], callback) => {
							let {issueTime = ''} = safe.formData
							if (value.length > 0 && issueTime) {
								const [start, end] = [new Date(value[0]).getTime(), new Date(issueTime).getTime()]
								if (start < end) {
									callback(new Error('发送时间不能大于生效时间！'))
								}
							}
							callback()
						},
					},
				],
			},
			{
				label: '生效时间',
				prop: 'effectiveTime',
				display: false,
				width: 120,
				formatter: ({effectiveTime}) => {
					return effectiveTime ? effectiveTime : '--'
				},
				// type: 'datetime',
				// pickerOptions: {
				// 	disabledDate(time) {
				// 		return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
				// 	},
				// },
				// format: 'yyyy-MM-dd HH:mm:ss',
				// valueFormat: 'yyyy-MM-dd HH:mm:ss',
				// defaultTime: ['12:00:00'],
				// rules: [
				// 	{
				// 		required: true,
				// 		message: '请选择生效时间',
				// 		trigger: 'blur',
				// 	},
				// ],
			},
			{
				label: '失效时间',
				prop: 'expiryTime',
				display: false,
				type: 'datetime',
				width: 120,
				formatter: ({expiryTime}) => {
					return expiryTime ? expiryTime : '--'
				},
				// pickerOptions: {
				// 	disabledDate(time) {
				// 		return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
				// 	},
				// },
				// format: 'yyyy-MM-dd HH:mm:ss',
				// valueFormat: 'yyyy-MM-dd HH:mm:ss',

				// rules: [
				// 	{
				// 		required: true,
				// 		message: '请选择生效时间',
				// 		trigger: 'blur',
				// 	},
				// 	{
				// 		validator: (rule, value, callback) => {
				// 			let {effectiveTime = ''} = safe.formData
				// 			if (value && effectiveTime) {
				// 				const [start, end] = [new Date(effectiveTime).getTime(), new Date(value).getTime()]
				// 				if (start > end) {
				// 					callback(new Error('生效时间不能大于失效时间'))
				// 				}
				// 			}
				// 			callback()
				// 		},
				// 	},
				// ],
			},
			// {
			//   label: '发送渠道',
			//   prop: 'channelIds',
			//   width: 120,
			//   display: false,
			//   dataType: 'string',
			//   multiple: true,
			//   type: 'select',
			//   formslot: true,
			//   span: 24,
			//   props: {
			//     label: 'name',
			//     value: 'id',
			//   },
			//   dicData: [],
			//   // dicUrl: '/dist/distChannel/list',
			//   // dicQuery: {parentId: 0},
			//   // dicFormatter: ({data}) => {
			//   //   return data;
			//   // },
			//   rules: [{
			//     required: true,
			//     message: '请选择发送渠道',
			//     trigger: 'blur',
			//   }],
			// },
			{
				label: '是否全量渠道',
				prop: 'isAllChannels',
				type: 'select',
				display: false,
				row: true,
				dicData: [
					{
						label: '全量渠道',
						value: 'ALL',
					},
					{
						label: '指定渠道',
						value: 'SPECIFY',
					},
				],
				rules: [
					{
						required: true,
						message: '请选择是否全量渠道',
						trigger: 'blur',
					},
				],
			},
			{
				label: '发送渠道',
				prop: 'channelIds',
				width: 120,
				hide: true,
				row: true,
				span: 24,
				display: false,
				formslot: true,
				rules: [
					{
						required: true,
						message: '请选择发送渠道',
						trigger: 'blur',
					},
				],

				// multiple: true,
				// props: {
				//   label: 'name',
				//   value: 'id',
				// },
				// remote: true,
				// filterable: true,
				// dicUrl: '/dist/distChannel/page?parentId=0&current=1&size=10&queryType=1&name={{key}}',
				// dicFormatter: ({data = {}}) => {
				//   return data.records || [];
				// },
				// rules: [{
				//   required: true,
				//   message: '请选择发送渠道',
				//   trigger: 'blur',
				// }],
			},
			{
				label: '是否启用',
				prop: 'enableStatus',
				type: 'switch',
				value: 'OFF',
				row: true,
				dicData: [
					{
						label: '停用',
						value: 'OFF',
					},
					{
						label: '启用',
						value: 'ON',
					},
				],
				rules: [
					{
						required: true,
						message: '请选择是否启用',
						trigger: 'blur',
					},
				],
			},
			{
				//发放状态，UNISSUE未发放，ISSUED已发放
				label: '发放状态',
				prop: 'issueStatus',
				addDisplay: false,
				editDisplay: false,
				dicData: [
					{
						label: '未发放',
						value: 'UNISSUE',
					},
					{
						label: '已发放',
						value: 'ISSUED',
					},
				],
			},
			{
				label: '创建时间',
				prop: 'createTime',
				addDisplay: false,
				editDisplay: false,
			},
			{
				label: '更新时间',
				prop: 'updateTime',
				addDisplay: false,
				editDisplay: false,
			},
			{
				label: '备注',
				prop: 'description',
				type: 'textarea',
				width: 120,
				overHidden: true,
				row: true,
				span: 24,
			},
		],
	}
}

export const couponAfterOneList = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		addBtn: false,
		excelBtn: false,
		editBtn: false,
		align: 'center',
		menuAlign: 'center',
		menuWidth: 120,
		searchLabelWidth: 100,
		column: [
			{
				label: '佣金券ID',
				prop: 'id',
			},
			{
				label: '佣金券名称',
				prop: 'name',
				search: true,
				width: 160,
				formatter: ({coupon: {name = ''}}) => name,
			},
			{
				label: '主渠道名称',
				prop: 'channelId',
				hide: true,
				search: true,
			},
			{
				label: '主渠道名称',
				prop: 'channelName',
				width: 160,
				formatter: ({channel: {name = ''} = {}}) => name,
			},
			{
				label: '保单号',
				prop: 'policyNo',
				search: true,
				width: 180,
				formatter: ({policyNo = '--'}) => policyNo,
			},
			{
				label: '奖励费率',
				prop: 'feeRate',
				width: 80,
				formatter: ({coupon: {feeRate = 0}}) => `${feeRate / 100}%`,
			},
			{
				label: '生效时间',
				prop: 'effectiveTime',
				type: 'datetime',
			},
			{
				label: '失效时间',
				prop: 'expiryTime',
				type: 'datetime',
			},
			{
				label: '使用时间',
				prop: 'useTime',
				type: 'datetime',
				formatter: ({useTime = '--'}) => useTime,
			},
			{
				label: '创建时间',
				prop: 'createTime',
				addDisplay: false,
				editDisplay: false,
			},
			{
				label: '更新时间',
				prop: 'updateTime',
				addDisplay: false,
				editDisplay: false,
			},
			{
				label: '备注',
				prop: 'description',
				overHidden: true,
				type: 'textarea',
				overHidden: true,
				width: 120,
				formatter: ({coupon: {description = ''}}) => description,
			},
		],
	}
}

export const couponFrontUsedList = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		addBtn: false,
		excelBtn: false,
		menu: false,
		align: 'center',
		menuAlign: 'center',
		searchLabelWidth: 100,
		column: [
			{
				label: '佣金券名称',
				prop: 'name',
				search: true,
				width: 120,
				rules: [
					{
						required: true,
						message: '请输入佣金券名称',
						trigger: 'blur',
					},
				],
				formatter: ({coupon: {name = ''}}) => name,
			},
			{
				label: '保单号',
				prop: 'policyNo',
				search: true,
				width: 180,
				formatter: ({policyNo = '--'}) => policyNo,
			},
			{
				label: '总保费(元)',
				prop: 'payMoney',
				width: 120,
			},
			{
				label: '费率',
				prop: 'feeRate',
				width: 120,
			},
			{
				label: '佣金(元)',
				prop: 'fee',
				width: 120,
			},
			{
				label: '生效时间',
				prop: 'effectiveTime',
				type: 'datetime',
			},
			{
				label: '失效时间',
				prop: 'expiryTime',
				type: 'datetime',
			},
			{
				label: '使用时间',
				prop: 'useTime',
				type: 'datetime',
				formatter: ({useTime = '--'}) => useTime,
			},
			{
				//使用状态，UNUSED未使用，USED已使用
				label: '使用状态',
				prop: 'useStatus',
				addDisplay: false,
				editDisplay: false,
				type: 'select',
				width: 80,
				dicData: [
					{
						label: '未使用',
						value: 'UNUSED',
					},
					{
						label: '已使用',
						value: 'USED',
					},
				],
			},
			{
				label: '备注',
				prop: 'description',
				type: 'textarea',
				width: 200,
				formatter: ({coupon: {description = ''}}) => description,
			},
		],
	}
}

//统计
export const couponUsageList = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		addBtn: false,
		excelBtn: false,
		menu: false,
		align: 'center',
		menuAlign: 'center',
		column: [
			{
				label: '渠道名称',
				prop: 'channelName',
				search: true,
			},
			{
				label: '总数量',
				prop: 'totalCount',
			},
			{
				label: '已使用数量',
				prop: 'usedCount',
			},
			//expiredCount 已失效数量、availableCount 可使用数量
			{
				label: '已失效数量',
				prop: 'expiredCount',
			},
			{
				label: '可使用数量',
				prop: 'availableCount',
			},
			{
				label: '有效期',
				prop: 'validTime',
				type: 'datetime',
				searchRange: true,
				search: true,
				hide: true,
				valueFormat: 'yyyy-MM-dd HH:mm:ss',
				format: 'yyyy-MM-dd HH:mm:ss',
				defaultTime: ['00:00:00', '23:59:59'],
				startPlaceholder: '选择生效时间',
				endPlaceholder: '选择失效时间',
				rangeSeparator: '至',
				searchSpan: 12,
			},
		],
	}
}
